import { useTranslation } from 'react-i18next'
import { Location, Route, Routes } from 'react-router-dom'

import { lazyPage } from '@/lib/lazy-load'
import { ORG_ACL_ROUTE, ORG_ROUTE } from '@/shared/constants'
import { WrapperProps } from '@/shared/routes'
import { HorizontalMenu } from '@/components'
import Layout, { LayoutLoading } from '@/components/Layout'
import { PageUnauthorized } from '@/components/PageUnauthorized'

import useDetailACL from './hooks/useDetailACL'

const OrgDetailACLForOrg = lazyPage(() => import('./OrgDetailACLForOrg'))
const OrgDetailACLForTeam = lazyPage(() => import('./OrgDetailACLForTeam'))

// access control routes config
const aclRoutes = [
  {
    index: true,
    name: 'Organization ACL',
    component: OrgDetailACLForOrg,
  },
  {
    path: 'team',
    name: 'Team ACL',
    component: OrgDetailACLForTeam,
  },
]

/**
 * pre process plugin nav link
 */
function aclNavLink(path: string, location: Location, id?: string) {
  const pathname = location.pathname
  const withSlash = path ? `/${path}` : ''
  const ident = id ? id : pathname.split('/')[2]
  return `${ORG_ROUTE}/${ident}/${ORG_ACL_ROUTE}${withSlash}`
}

/**
 * Org ACL Routes
 */
export default function OrgACLRoutes({ title }: WrapperProps) {
  const { t } = useTranslation()
  const { isLoading, canEither, rules, location, currentOrg, setIsSaved, isSaved } = useDetailACL()

  if (isLoading) {
    return <LayoutLoading title={title} />
  }

  return !canEither ? (
    <Layout title={title}>
      <PageUnauthorized />
    </Layout>
  ) : rules !== undefined ? (
    <Layout
      title={title}
      beforeContent={
        <HorizontalMenu
          menu={aclRoutes}
          getTo={(path) => {
            return aclNavLink(path, location, currentOrg?.id)
          }}
        />
      }
      actions={
        isSaved ? (
          <>
            <div className='text-primary-500 font-medium'>{t('Changes saved!')}</div>
          </>
        ) : undefined
      }
    >
      <div className='pb-8'>
        <div className='overflow-auto'>
          <Routes>
            {aclRoutes.map(({ component: Comp, ...r }) => {
              return (
                <Route
                  index={r.index}
                  path={r.index ? undefined : r.path}
                  key={r.name}
                  element={<Comp rules={rules} setIsSaved={setIsSaved} />}
                />
              )
            })}
          </Routes>
        </div>
      </div>
    </Layout>
  ) : (
    <Layout title={title}>Something wrong</Layout>
  )
}
